export const currencyOptions = {
  USD: {
    key: 'USD',
    label: 'US dollar',
    symbol: '$',
  },
  AUD: {
    key: 'AUD',
    label: 'Australian dollar',
    symbol: 'A$',
  },
  GBP: {
    key: 'GBP',
    label: 'British pound',
    symbol: '£',
  },
  EUR: {
    key: 'EUR',
    label: 'Euro',
    symbol: '€',
  },
  JPY: {
    key: 'JPY',
    label: 'Japanese yen',
    symbol: '¥',
  },
  INR: {
    key: 'INR',
    label: 'Indian rupee',
    symbol: '₹',
  },
}

export const getCurrencyLabelForDisplay = (currency: string) => {
  const currencyData = currencyOptions[currency as keyof typeof currencyOptions]
  if (!currencyData) {
    console.warn(`Currency "${currency}" not found in currencyOptions`)
    return currency
  }
  return `${currencyData.label} | ${currency}(${currencyData.symbol})`
}
